<div class="header d-print-none">
  <img class="cloud leftToRight" src="./assets/img/wolke_4.png" alt="" />
  <img class="cloud rightToLeft" src="./assets/img/wolke_4.png" alt="" />

  <div class="container">
    <div class="row-1">
      <div style="margin-top: 5vh; display: flex">
        <markant-icon *ngIf="checkLogo()" style="margin-right: 0.5vw" src="./assets/svg/cheque.svg" class="markant-icon"></markant-icon>
        <h3 class="title">{{ title }}</h3>
      </div>
    </div>
    <div class="links d-print-none" [class.align-left]="alignLeft">
      <ng-content ngProjectAs="[link]"> </ng-content>
    </div>
  </div>
</div>
